
const regexIso8601 = /^\d{4}-[01]\d-[0-3]\dT[0-2]\d:[0-5]\d:[0-5]\d\.\d+Z?/;

/**
 * will not be migrated in NG, only used in user-settings.js, wich will not be migrated
 */
export function convertDateStringsToDates(input) {
  // Ignore things that aren't objects.
  if (typeof input !== 'object') return input;

  for (let key in input) {
    if (!input.hasOwnProperty(key)) continue;

    let value = input[key];
    let match;
    if (typeof value === 'string') {
      match = value.match(regexIso8601);
    }
    // Check for string properties which look like dates.
    if (typeof value === 'string' && (match)) {
      let milliseconds = Date.parse(match[0]);
      if (!isNaN(milliseconds)) {
        input[key] = new Date(milliseconds);
      }
    } else if (typeof value === 'object') {
      // Recurse into object
      convertDateStringsToDates(value);
    }
  }
}

/**
 * buggy buggy buggy buggy, doesn't work as it should
 * should be fixed after testing all callers
 * @deprecated use angular version (fixed) in utils.service.ts
 */
export function intRange(start = 0, end = 0, step = 1) {
  return [...new Array(end - start + 1)].map((el, idx, arr) => idx * step);
}

export const utf8ToBase64 = (str) => {
  const encoder = new TextEncoder();
  const uint8Array = encoder.encode(str);

  let base64String = '';
  for (let i = 0; i < uint8Array.length; i++) {
    base64String += String.fromCharCode(uint8Array[i]);
  }
  return btoa(base64String);
}

export const base64ToUtf8 = (base64) => {
  const byteString = atob(base64);
  const decoder = new TextDecoder();
  return decoder.decode(new Uint8Array([...byteString].map(char => char.charCodeAt(0))));
}